export default __webpack_public_path__ + "static/media/Storage Racks.66f61a30.png";